/** Created by azhou on 2019/3/22.*/
<template>
  <div>
        <div class="d-center-start w-100 mb-3">
            <left-text leftText="订单号"/><span v-html="currentItem.oid"></span>
        </div>
        <div class="d-center-start w-100 mb-3">
            <left-text leftText="门店类型"/><span>{{currentItem.store_type | formatVar('StoreType')}}</span>
        </div>
        <div class="d-center-start w-100 mb-3" v-for="item in showDetailArr" :key="item.name">
            <left-text :leftText="item.name"/><span v-html="currentItem[item.value]"></span>
        </div>
        <div class="d-center-start w-100 mb-3">
            <left-text leftText="待打款金额"/><span v-html="currentItem.payment_pay/100+'元'"></span>
        </div>
        <div class="d-center-start w-100 mb-3">
            <left-text leftText="手续费"/><span v-html="currentItem.charge/100+'元'"></span>
        </div>
        <div class="d-center-start w-100 mb-3">
            <left-text leftText="实际打款金额"/><span class="red" v-html="currentItem.fact_payment_pay/100+'元'"></span>
        </div>
        <div class="d-center-start w-100 mb-3">
            <left-text leftText="打款人"/><span v-html="currentItem.handle_name"></span>
        </div>
        <div class="d-center-start w-100 mb-3">
            <left-text leftText="打款时间"/><span >{{currentItem.handle_time| formatTimestamp(1)}}</span>
        </div>
        <div class="d-center-start w-100 mb-3">
            <left-text leftText="打款备注"/><span v-html="currentItem.remark?currentItem.remark:'无'"></span>
        </div>
        <!-- <div class=" name">订单号:{{ruleForm.oid}}</div>
        <div class=" name">所属酒店:{{hotel_title}}</div> -->
        <el-form :model="ruleForm" :rules="region" ref="ruleForm" label-width="90px" class="demo-ruleForm" label-position="top" size="small" >
            <el-form-item label="回单号" prop="receipt_no" class="lie">
              <el-input v-model="ruleForm.receipt_no" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="备注" class="lie">
                <el-input type="text" v-model="ruleForm.remark"  maxlength="20" show-word-limit></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="$emit('finance');">取 消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
        </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions,mapState,mapMutations} from 'vuex'
  export default {
    name: 'FlinReceipt',
    props:{
        currentItem:{},
    },
    data() {
      return {
        ruleForm: {
            pay_id:'',
            receipt_no: '',
            remark:'',
        },
        region: {
            receipt_no: [
                { required: true, message: '请输入回单号', trigger: 'blur' },
            ],
        },
        showDetailArr:[
          {name:'银行卡所属',value:'truename'},{name:'开户银行',value:'bank_name'},{name:'支行名称',value:'branch'},{name:'银行卡号',value:'bank_card'}
        ],
        hotel_title:'',  
      }
    },
    mounted() {
        this.ruleForm.receipt_no=this.currentItem.receipt_no;
        this.ruleForm.remark=this.currentItem.remark;
        this.ruleForm.pay_id=this.currentItem.pay_id;
    },
    methods:{
        ...mapActions(['adminPaymentModify']),
              //打款
      submitForm(formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.adminPaymentModify({
                  data:this.ruleForm,
                  successFun: () => {
                         this.$emit('financeList');
                         this._alert('修改成功');
                  }
              }); 
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
    }
  }
</script>
<style lang="css" scoped>
  .commission{
    display: flex;
    justify-content: space-between;
  }
  .refund_fee{
    font-size: 13px;
    margin-top: 2px;
    color:brown;
  }
  .list-item-col{
    white-space: pre-line;
  }
  .name{
      text-align: left;
  }
  .lie{
    margin-right: 16px;
  }
  .demo-ruleForm{
    width: 96%;
    margin: 0 auto;
  }
  </style>
  <style>
    .demo-ruleForm .el-form-item__label{
      float: left;
    }
  </style>